import {
  getExamplePromptsMN,
  getExamplePromptsNutrigen,
  getExamplePromptsSylva,
  getLoadingTextMN,
  getLoadingTextNutrigen,
  getLoadingTextSylva
} from "./Text";

import AskMnLogo from "../media/AskMnLogo400.png";
import NutrigenLogo from "../media/NutrigenLogo282.png";
import SylvaLogo from "../media/SylvaLogo378.png";

export const bots = {
  askMN: {
    id: "askMN",
    chatbaseId: process.env.REACT_APP_CHATBASE_CHATBOT_ID_ASK_MOTHER_NATURE,
    name: "Ask Mother Nature AI™",
    logo: AskMnLogo,
    menuDescription: "Natural Wellness & Phytochemistry",
    newChatSubtext: "Bridging the gap between modern science & ancient wisdom",
    examplePrompts: getExamplePromptsMN(),
    loadingText: getLoadingTextMN()
  },
  sylva: {
    id: "sylva",
    chatbaseId: process.env.REACT_APP_CHATBASE_CHATBOT_ID_SYLVA,
    name: "Sylva AI™",
    logo: SylvaLogo,
    menuDescription: "Mental & Emotional Well-Being",
    newChatSubtext: "Compassionate support for emotional well-being",
    examplePrompts: getExamplePromptsSylva(),
    loadingText: getLoadingTextSylva()
  },
  nutrigen: {
    id: "nutrigen",
    chatbaseId: process.env.REACT_APP_CHATBASE_CHATBOT_ID_NUTRIGEN,
    name: "NutriGen AI™",
    logo: NutrigenLogo,
    menuDescription: "Advanced Nutrition Guidance",
    newChatSubtext: "Science-backed nutrition guidance for optimal health",
    examplePrompts: getExamplePromptsNutrigen(),
    loadingText: getLoadingTextNutrigen()
  }
};
